import { Box, styled } from "@mui/material";
import PropTypes from "prop-types";

const BoxStyled = styled(Box)(({ theme }) => ({
  margin: "auto",
  width: "100% !important",
  height: "100%",
  padding: theme.spacing(0, 2),
  [theme.breakpoints.up("xl")]: {
    width: theme.breakpoints.values["xl"] + (theme.breakpoints.unit || "px"),
  },
}));

export const Wrapper = ({ children, sx, ...props }) => {
  return (
    <BoxStyled sx={sx} {...props}>
      {children}
    </BoxStyled>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};
